import styled from "styled-components";
import { mediaMaxWidth } from "../../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.header`
  position: fixed;
  width: 100vw;
  z-index: 2;
  display: flex;
  height: 90px;
  justify-content: center;
  align-items: center;
  background-color: #e3e4e6;

  .fade-appear {
    position: relative;
    opacity: 0;
    z-index: 1;
    top: 20px;

    &.fade-appear-active {
      opacity: 1;
      top: 0;
      transition: all 300ms ease-in;
    }
  }

  ${mediaMaxWidth.tablet} {
    height: 70px;
  }
`;

export const Container = styled.div`
  width: 1140px;
  display: flex;
  justify-content: space-between;

  ${mediaMaxWidth.mediumDesktop} {
    width: 960px;
  }

  ${mediaMaxWidth.smallDesktop} {
    width: calc(100vw - 40px);
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
  }
`;

export const Logo = styled.img`
  height: 50px;
  width: auto;

  ${mediaMaxWidth.phone} {
    height: 25px;
  }
`;
